(() => {
  const bindMaplShop = (root = document) => {
    root.querySelectorAll('[data-mapl-shop-variant]').forEach((select) => {
      if (select.dataset.maplShopBound === 'true') return;
      select.dataset.maplShopBound = 'true';

      select.addEventListener('change', () => {
        const option = select.options[select.selectedIndex];
        const form = select.closest('form');
        const card = select.closest('.mapl-shop-product');
        if (!option || !form || !card) return;

        const price = card.querySelector('[data-mapl-shop-price]');
        const button = form.querySelector('.mapl-shop-product__button');
        const label = button ? button.querySelector('.mapl-button__label') : null;
        const isAvailable = option.dataset.available === 'true';

        if (price) price.textContent = option.dataset.price || '';
        if (button) {
          button.disabled = !isAvailable;
          button.setAttribute('aria-disabled', String(!isAvailable));
        }
        if (label) {
          label.textContent = isAvailable ? select.dataset.addLabel : select.dataset.soldLabel;
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bindMaplShop());
  } else {
    bindMaplShop();
  }

  document.addEventListener('shopify:section:load', (event) => bindMaplShop(event.target));
})();
